export default {
  Default: {
    isDefault: true,
    value: [
      'Inter, system-ui, -apple-system, sans-serif',
    ],
    type: 'sans-serif',
    url: 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap',
  },
  Mono: {
    value: [
      'JetBrains Mono, Fira Code, monospace',
    ],
    type: 'monospace',
    url: 'https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;500;700&display=swap',
  },
}
